import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../../components-react/ReactAlert";
import { addLead, addLeadFollowup } from "../../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../../redux/reducers/commonApiSlice";
import {
  fetchCustomerIntentData,
  fetchFollowupStatusData,
} from "../../../../redux/reducers/apiSlice";
import { fetchLMSFollowupsData } from "../../../../redux/prospect-reducers/prospectSlice";
import { leadPlanTypes, times } from "../../../common-data/DropdowData";
import { currentMonthCurrentDate } from "../../../common-data/Converts";
import SelectDropdownLabel from "../../../components-react/SelectDropdownLabel";
import { validateLeadFolloupForm } from "../../functions/LeadValidations";
import "../../../../styles/lead-mangement/lead-followup-v2.css";
import {
  AddRemarksIcon,
  ScheduleFollowupButtonIcon,
  ScheduleFollowupIcon,
  StartIcon,
} from "../LMSV2Icons";
import {
  CalendarIcon,
  ClockIcon,
  FileIcon,
  FlashLightIcon,
  RupeeIcon,
  TargetIcon,
  TrendingUp,
} from "../../../../images/icons/icons";

const LeadFollowupNewUI = ({ userInfoData, rowData, isTable, closeModal }) => {
  const dispatch = useDispatch();
  const { postPutLoading, postPutLoading1 } = useSelector(
    (state) => state.common
  );
  const { customerIntentCategory, followupStatuses } = useSelector(
    (state) => state.api
  );
  const { lmsFollowups, lmsFollowupsLoading, lmsFollowupsError } = useSelector(
    (state) => state.prospects
  );

  const [allFollowupsDatas, setAllFollowupsDatas] = useState([]);
  const [timesOption, setTimesOption] = useState([]);
  const [customerIntents, setCustomerIntents] = useState([]);
  const [followupStatus, setFollowupStatus] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const initialFormValues = {
    scheduledOn: "",
    selCustomerIntent: "",
    followupStatus: "",
    remarks: "",
    nextFollowupDate: "",
    nextFollowupTime: "",
    expectedCloserDate: "",
    selectedPlan: "",
    leadValueAmount: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);

  const { lead_id: leadId } = rowData || {};

  const sortedFollowupData =
    allFollowupsDatas?.length > 0
      ? [...allFollowupsDatas].sort(
          (a, b) => b?.follow_up_number - a?.follow_up_number
        )
      : [];

  const copiedFollowups = [...allFollowupsDatas] || [];
  const filteredFollowups = copiedFollowups.sort((a, b) =>
    moment(b.scheduled_on)?.tz("Asia/Kolkata")?.diff(a.scheduled_on)
  );
  const prevFollowupData = filteredFollowups[0];
  const followupStage = sortedFollowupData?.[0]?.follow_up_number || 0;

  const is_Next_Followup_Required =
    formValues.followupStatus &&
    formValues.followupStatus?.next_followup_required;
  const is_Plan_Info_Required =
    formValues.followupStatus && formValues.followupStatus?.price_required;

  function getLMSFollowups(filters) {
    dispatch(
      fetchLMSFollowupsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getCustomerIntent(filters) {
    dispatch(
      fetchCustomerIntentData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getFollowupStatuses(filters) {
    dispatch(
      fetchFollowupStatusData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "nextFollowupDate") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        nextFollowupTime: "",
        expectedCloserDate: value,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    if (name === "selCustomerIntent") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        followupStatus: "",
      }));
      setFollowupStatus([]);
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleUpdateFollowup = async (
    payload,
    userDataAdd,
    userDataExpClosureDate
  ) => {
    const method = "PUT";
    const endpoint = addLeadFollowup;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        handleAddFollowup(userDataAdd);
        setIsSubmit(false);
        setFormValues(initialFormValues);
        setFormErrors({});
        callFunction();

        closeModal && closeModal();

        handleChangeCloserDate(userDataExpClosureDate);
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleAddFollowup = async (
    payload,
    isAddUpdate,
    userDataExpClosureDate
  ) => {
    const method = "POST";
    const endpoint = addLeadFollowup;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(initialFormValues);
        setFormErrors({});
        callFunction();
        handleChangeCloserDate(userDataExpClosureDate);
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleChangeCloserDate = async (payload) => {
    const method = "PUT";
    const endpoint = addLead;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        console.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making PUT request:", error);
    }
  };

  const callFunction = () => {
    if (rowData?.lead_id) {
      const sendableFilters = {
        lead_id: rowData?.lead_id,
      };
      getLMSFollowups(sendableFilters);
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateLeadFolloupForm(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (rowData?.lead_id) {
      const sendableFilters = {
        lead_id: rowData?.lead_id,
      };
      getLMSFollowups(sendableFilters);
    }
  }, []);

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 10,
      status: "active",
    };

    getCustomerIntent(filters);
  }, []);

  useEffect(() => {
    if (
      !lmsFollowupsLoading &&
      !lmsFollowupsError &&
      lmsFollowups?.status &&
      lmsFollowups?.data
    ) {
      setAllFollowupsDatas(lmsFollowups.data);
    } else {
      setAllFollowupsDatas([]);
    }
  }, [lmsFollowupsLoading, lmsFollowups]);

  useEffect(() => {
    if (formValues.selCustomerIntent?.value) {
      const filters = {
        page: 1,
        limit: 200,
        status: "active",
        intent_id: formValues.selCustomerIntent.value,
      };

      getFollowupStatuses(filters);
    }
  }, [formValues.selCustomerIntent]);

  useEffect(() => {
    if (
      customerIntentCategory?.status &&
      customerIntentCategory?.data?.length > 0
    ) {
      const allIntents = customerIntentCategory?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name || "",
        next_followup_required: item?.next_followup_required || 0,
      }));

      setCustomerIntents(allIntents);
    } else {
      setCustomerIntents([]);
    }
  }, [customerIntentCategory]);

  useEffect(() => {
    if (followupStatuses?.status && followupStatuses?.data?.length > 0) {
      const allFollowups = followupStatuses?.data?.map((item) => ({
        value: item?.value || "",
        label: item?.display_label || "",
        next_followup_required: item?.next_followup_required || false,
        price_required: item?.price_required || 0,
      }));

      setFollowupStatus(allFollowups);
    } else {
      setFollowupStatus([]);
    }
  }, [followupStatuses]);

  useEffect(() => {
    const today = new Date();
    let filteredTimesOptions;

    if (formValues.nextFollowupDate) {
      const selectedDate = new Date(formValues.nextFollowupDate);
      const currentHour = today.getHours();
      const currentMinute = today.getMinutes();

      if (selectedDate.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
        filteredTimesOptions = times.filter((time) => {
          const [timeHour, timeMinute] = time.value.split(":").map(Number);
          return (
            timeHour > currentHour ||
            (timeHour === currentHour && timeMinute >= currentMinute)
          );
        });
      } else {
        filteredTimesOptions = times;
      }
    } else {
      filteredTimesOptions = [];
    }

    setTimesOption(filteredTimesOptions);
  }, [formValues.nextFollowupDate]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const currentDate = moment().tz("Asia/Kolkata");

      if (filteredFollowups.length > 0) {
        const nextFollowupDateTime = moment(
          `${formValues.nextFollowupDate} ${formValues.nextFollowupTime?.value}`,
          "YYYY-MM-DD HH:mm"
        )
          ?.tz("Asia/Kolkata")
          ?.utcOffset("+05:30");
        const prevNextFollowUpDate = moment(prevFollowupData?.scheduled_on)
          ?.tz("Asia/Kolkata")
          ?.utcOffset("+05:30");

        const differenceInMinutes = nextFollowupDateTime.diff(
          currentDate,
          "minutes"
        );
        const differenceInHoursDNP = Math.abs(
          nextFollowupDateTime.diff(prevNextFollowUpDate, "hours")
        );

        if (
          formValues.followupStatus === "dnp" &&
          (differenceInHoursDNP < 2 || differenceInHoursDNP > 24)
        ) {
          toast.error(
            "Next follow-up date and time should be between 3 hours and 24 hours for DNP status."
          );
          return;
        } else if (differenceInMinutes < 30) {
          toast.error(
            "Next follow-up date and time should be at least 30 minutes after the current time."
          );
          return;
        } else {
          const userDataUpdate = {
            lead_id: leadId,
            uid: prevFollowupData?.uid,
            customer_intent_id: formValues.selCustomerIntent?.value || "",
            follow_up_status: formValues.followupStatus?.value || "",
            scheduled_on: prevFollowupData?.scheduled_on || "",
            next_follow_up_date:
              formValues.nextFollowupDate && formValues.nextFollowupTime?.value
                ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                : "",
            remarks: formValues.remarks,
            lead_value: formValues.leadValueAmount || 0,
            duration: formValues.selectedPlan?.value || "",
          };

          const userDataAdd = {
            lead_id: leadId,
            lead_value: formValues.leadValueAmount || 0,
            duration: formValues.selectedPlan?.value || "",
            followUpDetails: [
              {
                added_by: userInfoData?.uid || userInfoData?.user_id,
                follow_up_status: "pending",
                scheduled_on:
                  formValues.nextFollowupDate &&
                  formValues.nextFollowupTime?.value
                    ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                    : "",
                next_follow_up_date: "",
                remarks: "",
              },
            ],
          };

          const userDataExpClosureDate = {
            lead_id: leadId,
            uid: prevFollowupData?.uid,
            expected_closure_date: formValues.expectedCloserDate || "",
            customer_intent_id: formValues.selCustomerIntent?.value || "",
          };

          const handleConfirm = async () => {
            handleUpdateFollowup(
              userDataUpdate,
              userDataAdd,
              userDataExpClosureDate
            );
          };

          showConfirmAlert(
            handleConfirm,
            `Are you sure!`,
            "Edit Form",
            "Add Follow-up"
          );
        }
      } else {
        const userData = {
          lead_id: leadId,
          lead_value: formValues.leadValueAmount || 0,
          duration: formValues.selectedPlan?.value || "",
          followUpDetails: [
            {
              added_by: userInfoData?.uid || userInfoData?.user_id,
              customer_intent_id: formValues.selCustomerIntent?.value || "",
              follow_up_status: formValues.followupStatus?.value || "",
              scheduled_on: "",
              next_follow_up_date:
                formValues.nextFollowupDate &&
                formValues.nextFollowupTime?.value
                  ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                  : "",
              remarks: formValues.remarks,
              is_first: 1,
            },
            {
              added_by: userInfoData?.uid || userInfoData?.user_id,
              follow_up_status: "pending",
              scheduled_on:
                formValues.nextFollowupDate &&
                formValues.nextFollowupTime?.value
                  ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                  : "",
              next_follow_up_date: "",
              remarks: "",
            },
          ],
        };

        const userDataExpClosureDate = {
          lead_id: leadId,
          expected_closure_date: formValues.expectedCloserDate || "",
          customer_intent_id: formValues.selCustomerIntent?.value || "",
        };

        const handleConfirm = async () => {
          handleAddFollowup(userData, true, userDataExpClosureDate);
        };

        showConfirmAlert(
          handleConfirm,
          `Are you sure!`,
          "Edit Form",
          "Add Follow-up"
        );
      }
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="lead-followup-new-ui-root">
      <div className="lead-followup-new-ui-header">
        <div className="lead-followup-new-ui-header-icon">
          <ScheduleFollowupIcon />
        </div>
        <div className="lead-followup-new-ui-header-text">
          <h2 className="lead-followup-new-ui-title">Schedule Follow-up</h2>
          <p className="lead-followup-new-ui-subtitle">
            Plan your next interaction with this lead
          </p>
        </div>
      </div>

      <div className="lead-followup-new-ui-info-cards">
        <div className="lead-followup-new-ui-info-card lead-followup-new-ui-info-card-blue">
          <div className="lead-followup-new-ui-info-card-content">
            <div className="lead-followup-new-ui-info-card-header">
              <div className="lead-followup-new-ui-info-card-icon">
                <TrendingUp />
              </div>
              <div className="lead-followup-new-ui-info-card-label">
                FOLLOW-UP STAGE
              </div>
            </div>
            <div className="lead-followup-new-ui-info-card-value">
              Stage {followupStage || 0}
            </div>
          </div>
        </div>

        <div className="lead-followup-new-ui-info-card lead-followup-new-ui-info-card-green">
          <div className="lead-followup-new-ui-info-card-content">
            <div className="lead-followup-new-ui-info-card-header">
              <div className="lead-followup-new-ui-info-card-icon">
                <ClockIcon color="#18a14b" />
              </div>
              <div className="lead-followup-new-ui-info-card-label">
                PREVIOUS FOLLOW-UP
              </div>
            </div>
            <div className="lead-followup-new-ui-info-card-value">
              {prevFollowupData?.scheduled_on
                ? moment(prevFollowupData.scheduled_on)
                    .tz("Asia/Kolkata")
                    .format("DD MMMM YYYY")
                : "-"}
            </div>
            <div className="lead-followup-new-ui-info-card-time">
              {prevFollowupData?.scheduled_on
                ? moment(prevFollowupData.scheduled_on)
                    .tz("Asia/Kolkata")
                    .format("hh:mm A")
                : ""}
            </div>
          </div>
        </div>
      </div>

      <div className="lead-followup-new-ui-section-header">
        <StartIcon />
        <span>NEW FOLLOW-UP DETAILS</span>
      </div>

      <form className="lead-followup-new-ui-form" onSubmit={onSumitForm}>
        <div className="lead-followup-new-ui-form-row">
          <div className="lead-followup-new-ui-form-group">
            <label className="lead-followup-new-ui-form-label">
              <TargetIcon color="#64748b" />
              Lead Intent{" "}
              <span className="lead-followup-new-ui-required">*</span>
            </label>
            <div
              className={`lead-followup-new-ui-select-wrapper commonWrapper ${
                formErrors.selCustomerIntent
                  ? "lead-followup-new-ui-form-error"
                  : ""
              }`}
            >
              <SelectDropdownLabel
                options={customerIntents}
                selectedOption={formValues.selCustomerIntent}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selCustomerIntent", selectedValue)
                }
                name="Lead Intent"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          <div className="lead-followup-new-ui-form-group">
            <label className="lead-followup-new-ui-form-label">
              <FlashLightIcon />
              Follow-Up Status{" "}
              <span className="lead-followup-new-ui-required">*</span>
            </label>
            <div
              className={`lead-followup-new-ui-select-wrapper commonWrapper ${
                formErrors.followupStatus
                  ? "lead-followup-new-ui-form-error"
                  : ""
              }`}
            >
              <SelectDropdownLabel
                options={followupStatus}
                selectedOption={formValues.followupStatus}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("followupStatus", selectedValue)
                }
                name="Select status"
                preventKeyboardOpen={true}
              />
            </div>
          </div>
        </div>

        {formValues.selCustomerIntent ? (
          <div className="lead-followup-new-ui-form-group">
            <label className="lead-followup-new-ui-form-label">
              <CalendarIcon color="#64748b" />
              Next Follow-up Date & Time
              {is_Next_Followup_Required && (
                <span className="lead-followup-new-ui-required">*</span>
              )}
            </label>
            <div className="lead-followup-new-ui-datetime-row">
              <input
                type="date"
                className={`lead-followup-new-ui-input lead-followup-new-ui-date-input ${
                  formValues.nextFollowupDate ? "date-has-value" : ""
                } ${
                  formErrors?.nextFollowupDate
                    ? "lead-followup-new-ui-form-error"
                    : ""
                }`}
                name="nextFollowupDate"
                value={formValues.nextFollowupDate}
                onChange={onChangeInput}
                min={currentMonthCurrentDate}
                placeholder="dd/mm/yyyy"
              />

              <div
                className={`lead-followup-new-ui-select-wrapper commonWrapper ${
                  formErrors.nextFollowupTime
                    ? "lead-followup-new-ui-form-error"
                    : ""
                }`}
              >
                <SelectDropdownLabel
                  options={timesOption}
                  selectedOption={formValues.nextFollowupTime}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("nextFollowupTime", selectedValue)
                  }
                  name="Select time"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>
          </div>
        ) : null}

        {is_Plan_Info_Required ? (
          <div className="lead-followup-new-ui-form-row">
            <div className="lead-followup-new-ui-form-group">
              <label className="lead-followup-new-ui-form-label">
                <FileIcon color="#64748b" />
                Plan <span className="lead-followup-new-ui-required">*</span>
              </label>
              <div
                className={`lead-followup-new-ui-select-wrapper commonWrapper ${
                  formErrors.selectedPlan
                    ? "lead-followup-new-ui-form-error"
                    : ""
                }`}
              >
                <SelectDropdownLabel
                  options={leadPlanTypes}
                  selectedOption={formValues.selectedPlan}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedPlan", selectedValue)
                  }
                  name="Plan"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            <div className="lead-followup-new-ui-form-group">
              <label className="lead-followup-new-ui-form-label">
                <RupeeIcon color="#64748b" />
                Lead Value{" "}
                <span className="lead-followup-new-ui-required">*</span>
              </label>
              <input
                type="number"
                placeholder="enter lead value"
                className={`lead-followup-new-ui-input ${
                  formErrors.leadValueAmount
                    ? "lead-followup-new-ui-form-error"
                    : ""
                }`}
                name="leadValueAmount"
                value={formValues.leadValueAmount}
                onChange={onChangeInput}
                min={0}
              />
            </div>
          </div>
        ) : null}

        <div className="lead-followup-new-ui-form-group">
          <label className="lead-followup-new-ui-form-label">
            <AddRemarksIcon />
            Add Remarks <span className="lead-followup-new-ui-required">*</span>
            <span className="lead-followup-new-ui-char-count">
              {formValues.remarks?.length || 0}/200
            </span>
          </label>
          <textarea
            name="remarks"
            className={`lead-followup-new-ui-textarea ${
              formErrors.remarks ? "lead-followup-new-ui-form-error" : ""
            }`}
            placeholder="Add notes about this follow-up... What was discussed? What are the next steps?"
            value={formValues.remarks}
            onChange={onChangeInput}
            maxLength={200}
          ></textarea>
        </div>

        <button
          type="submit"
          className="lead-followup-new-ui-submit-btn"
          disabled={postPutLoading || postPutLoading1}
        >
          <ScheduleFollowupButtonIcon />
          {postPutLoading || postPutLoading1
            ? "Scheduling..."
            : "Schedule Follow-Up"}
        </button>
      </form>
    </div>
  );
};

export default LeadFollowupNewUI;
